import React, { useEffect, useState } from "react";
import {
  Button,
  Grid,
  IconButton,
  Paper,
  styled,
  TextField,
  Typography,
} from "@mui/material";
import { t } from "i18next";

import Dropdown from "../../reusableComponents/components/generics/Dropdown";

import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormHelperText from "@mui/material/FormHelperText";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import { useTranslation } from "react-i18next";
import { Field, Form } from "react-final-form";
import CalendarPicker from "../../pickers/CalenderPicker";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchMedicalStaffInsureeByFilter,
  fetchPolicyHolderByInsuree,
  fetchPolicyHolderByInsureeByFilter,
  fetchPolicyHolderInfo,
  fetchPolicyholderInsureePicker,
  fetchVerifyByInsuree,
  GetInsuresByHealthFacility,
  loadingUser,
} from "../../action";
import { decodeId } from "../../utils/helper";

const StyledPaper = styled(Paper)(({ theme }) => ({
  ...theme.paper.paper,
}));

const StyledPaperHeader = styled(Grid)(({ theme }) => ({
  ...theme.paper.header,
  fontSize: 600,
  padding: ".8rem",
}));

function MedicalStaffFilter() {
  const token = localStorage.getItem("token");

  const { t } = useTranslation();

  const SignInSuccess = useSelector((state) => state);

  const hf_Uuid =
    SignInSuccess?.fosaReducer?.pickerHealthFacilityInsurees?.[0]?.uuid;

  const [dropValue, setDropValue] = React.useState(0);

  const [showCalendar, setShowCalendar] = React.useState(false);

  const [searchValue, setSearchValue] = useState("");

  const [label, setLabel] = React.useState("Enter CAMU No.");

  const [pageSize, setPageSize] = useState(10);

  const dispatch = useDispatch();

  const [filter, setFilter] = useState(false);

  const [currentUser, setCurrentUSer] = useState();
  const [policyHolder, setPolicyHolder] = useState();
  console.log("===> policyHolder", policyHolder);
  useEffect(() => {
    dispatch(loadingUser(token));
  }, []);
  useEffect(() => {
    if (SignInSuccess?.profileReducer?.currentUserResponseData) {
      setCurrentUSer(SignInSuccess?.profileReducer?.currentUserResponseData);
    }
  }, [SignInSuccess]);
  useEffect(() => {
    if (currentUser?.id) {
      dispatch(fetchPolicyHolderInfo(currentUser?.id));
    }
  }, [currentUser]);
  useEffect(() => {
    if (SignInSuccess?.profileReducer?.policyholderUserResponseData) {
      setPolicyHolder(
        SignInSuccess?.profileReducer?.policyholderUserResponseData?.[0]?.policyHolder
      );
    }
  }, [policyHolder, SignInSuccess]);

  const handleChange = (event) => {
    setDropValue(event.target.value);
    getLabel(event);
    setShowCalendar(false);
  };

  const handleSearch = (event) => {
    let params = buildQueryParams({
      filters: filter,
      pageSize,
    });
    dispatch(GetInsuresByHealthFacility(hf_Uuid, params));
  };

  const handleClear = (event) => {
    setSearchValue("");
    let params = buildQueryParams({
      filters: {},
      pageSize,
    });
    dispatch(GetInsuresByHealthFacility(hf_Uuid, params));
  };

  const onsubmit = (event) => {};

  const getLabel = (event) => {
    switch (event.target.value) {
      case 1:
        setLabel("EnterCAMUNo.");
        break;
      case 2:
        setLabel("EnterFirstName");
        break;
      case 3:
        setLabel("EnterLastName");
        break;
      // case 4:
      //   setLabel("Enter Phone No.");
      //   break;
      default:
        setLabel("EnterCAMUNo.");
        break;
    }
  };

  const searchType = [
    {
      value: 1,
      label: t("camuNo"),
    },
    {
      value: 2,
      label: t("First Name"),
    },
    {
      value: 3,
      label: t("Last Name"),
    },
    // {
    //   value: 4,
    //   label: t("Phone No."),
    // },
  ];

  const buildQueryParams = (state) => {
    let params = Object.keys(state.filters)
      .filter((f) => !!state.filters[f]["filter"])
      .map((f) => state.filters[f]["filter"]);
    if(hf_Uuid) {
      params.push(`hfUuid: "${hf_Uuid}"`);
    }
    if (!state.beforeCursor && !state.afterCursor) {
      params.push(`first: ${state.pageSize}`);
    }
    if (!!state.afterCursor) {
      params.push(`after: "${state.afterCursor}"`);
      params.push(`first: ${state.pageSize}`);
    }
    if (searchValue) {
      if (dropValue == 1) {
        params.push(`camuNumber_Icontains: "${searchValue}"`);
      }
      if (dropValue == 2) {
        params.push(`otherNames_Icontains: "${searchValue}"`);
      }
      if (dropValue == 3) {
        params.push(`lastName_Icontains: "${searchValue}"`);
      }
      if (dropValue == 4) {
        params.push(`insuree_Dob: "${searchValue}"`);
      }
      if (dropValue == 5) {
        params.push(`insuree_Phone_Icontains: "${searchValue}"`);
      }
    }
    if (!!state.beforeCursor) {
      params.push(`before: "${state.beforeCursor}"`);
      params.push(`last: ${state.pageSize}`);
    }
    if (!!state.orderBy) {
      params.push(`orderBy: ["${state.orderBy}"]`);
    }
    return params;
  };

  return (
    <Grid container>
      <Grid item xs={12}>
        <StyledPaper>
          <StyledPaperHeader>
            <Grid item alignItems="center">
              <Typography variant="h6">{t("searchInsuree")}</Typography>
            </Grid>
          </StyledPaperHeader>
          <Form
            autoComplete="off"
            onSubmit={(values) => {}}
            render={({ handleSubmit, form }) => (
              <form onSubmit={onsubmit}>
                <Grid
                  style={{
                    display: "flex",
                    marginLeft: ".5rem",
                    marginTop: "1rem",
                    marginBottom: "1rem",
                  }}
                >
                  <Grid item xs={3} className="common-input">
                    <Typography color="#000" fontSize="14">
                      {t("Search Criteria")}
                    </Typography>
                    <Field
                      name="typeOfSearch"
                      component={Dropdown}
                      options={searchType}
                      input={!!dropValue && dropValue}
                      onChange={(e) => handleChange(e)}
                    />
                  </Grid>
                  {dropValue != 0 && (
                    <Grid item xs={3} className="common-input">
                      <Typography color="#000" fontSize="24">
                        {t(label)}
                      </Typography>
                      {!showCalendar && (
                        <TextField
                          name="name"
                          value={searchValue}
                          onChange={(e) => setSearchValue(e.target.value)}
                          size="small"
                          type="text"
                          autoComplete="off"
                        />
                      )}
                    </Grid>
                  )}
                  {dropValue != 0 && (
                    <Grid
                      item
                      xs={8}
                      style={{ display: "flex", marginTop: "1.4rem" }}
                    >
                      <Grid item xs={3} className="common-input">
                        <Button
                          variant="contained"
                          color="primary"
                          disabled={!searchValue}
                          onClick={handleSearch}
                        >
                          {t("Search")}
                        </Button>
                      </Grid>
                      <Grid item xs={3} className="common-input">
                        <Button
                          variant="outlined"
                          color="primary"
                          onClick={handleClear}
                          style={{ marginLeft: "1rem" }}
                        >
                          {t("Clear")}
                        </Button>
                      </Grid>
                    </Grid>
                  )}
                </Grid>
              </form>
            )}
          />
        </StyledPaper>
      </Grid>
    </Grid>
  );
}

export default MedicalStaffFilter;
